import { useSelector } from 'react-redux'

import { selectTranslate } from '../../reducers/LocaleReducer/LocalReducer'
import { faConstruction } from '@fortawesome/pro-duotone-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

const STYLE = {
  '--fa-primary-color': '#ffffff',
  '--fa-primary-opacity': '1.0',
  '--fa-secondary-color': '#0066cc',
  '--fa-secondary-opacity': '0.95'
}

const UnderConstruction = () => {
  const t = useSelector(selectTranslate)

  return (
    <div className='flex-row' style={{ width: '100%', textAlign: 'center', padding: '30px' }}>
      <div style={{ width: '30%' }}>
        <FontAwesomeIcon icon={faConstruction} size='8x' style={STYLE} />
      </div>
      <div style={{ width: '70%' }}>
        <h1>{t('under_construction.title')}</h1>
        <p>{t('under_construction.description')}</p>
      </div>
    </div>
  )
}

export default UnderConstruction
